export default __webpack_public_path__ + "static/media/afric.258c868f.PNG";